import React from "react";
import HeaderText from '../../components/HeaderText'
import ReportButton from '../../components/ReportButton'
import AuthService from "../../controllers/AuthService";
import { Row, Col } from 'react-bootstrap'
import {Helmet} from "react-helmet";

const ReportOverviewPage = () => {
    return (
        <div className="ReportOverviewPage">
            <Helmet>
                <title>รายงานกิจกรรมค้นหาคุณค่าผ่านนิสัยเชิงบวก ประจำชั้น{AuthService.getCurrentUser().room && AuthService.getCurrentUser().room.displayName ? AuthService.getCurrentUser().room.displayName : ''} {AuthService.getCurrentUser().domain.displayName} - Mindsetmaker.co</title>
                <meta property="og:title"       content={`รายงานกิจกรรมค้นหาคุณค่าผ่านนิสัยเชิงบวก ประจำชั้น${AuthService.getCurrentUser().room && AuthService.getCurrentUser().room.displayName ? AuthService.getCurrentUser().room.displayName : ''} ${AuthService.getCurrentUser().domain.displayName} - Mindsetmaker.co`} />
                <meta property="og:description" content={`รายงานกิจกรรมการเรียนรู้จิตวิทยาเชิงบวกในห้องเรียน ด้วยเครื่องมือปรับใจ ของ ${AuthService.getCurrentUser().domain.displayName}`} />
            </Helmet>
            <Row>
                <Col className="text-center px-0">
                    <ReportButton />
                </Col>
            </Row>
        </div>

    );
};

export default ReportOverviewPage;
